import React from 'react';
import { Card } from 'antd';

interface AdPreviewProps {
    primaryText: string;
    headline: string;
    descriptionText: string;
    mediaUrl: string;
    facebookPage: string;
}

export const AdPreview: React.FC<AdPreviewProps> = ({
    primaryText,
    headline,
    descriptionText,
    mediaUrl,
    facebookPage,
}) => {
    // console.log(mediaUrl);

    return (
        <Card title="Ad Preview" bordered={false}>
            <div
                className="bg-white rounded-lg shadow-2xl max-w-[300px]"
            >
                <div className="flex justify-between items-center p-4">
                    <div className="flex items-center">
                        <div className="mr-3">
                            {/* <img
                                src={facebookPage}
                                className="w-10 h-10 rounded-full"
                                alt="Profile"
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                    const fallback = target.nextSibling as HTMLElement;
                                    fallback.style.display = 'flex';
                                }}
                            /> */}
                            <div
                                className="w-10 h-10 rounded-full bg-blue-500 text-white items-center justify-center"
                                style={{ display: facebookPage ? 'none' : 'flex' }}
                            >
                                {facebookPage?.[0]?.toUpperCase() || 'P'}
                            </div>
                        </div>
                        <div>
                            <h5 className="font-semibold text-sm">
                                {facebookPage || 'Page Name'}
                            </h5>
                            <div className="flex items-center text-gray-500">
                                <span className="text-xs mr-1">Sponsored</span>
                                <svg className="w-3 h-3" viewBox="0 0 24 24">
                                    <path
                                        fill="currentColor"
                                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <svg className="w-5 h-5 text-gray-500" viewBox="0 0 24 24">
                        <path
                            fill="currentColor"
                            d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                        />
                    </svg>
                </div>
                <h6
                    className="text-lg font-semibold mb-0 mt-0 truncate pl-2"
                >
                    {primaryText || 'Primary text'}
                </h6>

                {mediaUrl ? (
                    <img
                        src={mediaUrl}
                        alt="Ad creative"
                        className="w-full object-cover bg-grey-100 w-[100%]"
                        style={{ maxHeight: 400 }}
                    />
                ) : (
                    <div
                        className="bg-gray-100 flex items-center justify-center"
                        style={{ height: 250 }}
                    >
                        <div className="text-center text-gray-500">
                            <svg
                                className="w-12 h-12 mx-auto mb-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                            </svg>
                            <p className="text-sm">Ad Preview</p>
                        </div>
                    </div>
                )}

                <div className="p-4 bg-gray-100">
                    <div className="flex justify-between items-center bg-gray-100">
                        <div>
                            <p className="text-l text-gray-600 mb-0">WHATSAPP</p>
                            <h6
                                className="text-lg font-semibold mb-0 mt-0 truncate"
                                style={{ maxWidth: '150px' }}
                            >
                                {headline || 'Heading'}
                            </h6>
                            <p
                                className="text-gray-600 mb-4 truncate"
                                style={{ maxWidth: '150px' }}
                            >
                                {descriptionText || 'Description'}
                            </p>
                        </div>

                        <button className="flex items-center px-3 py-1 border border-green-800 text-green-800 rounded text-sm">
                            <svg className="w-4 h-4 mr-1" viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
                                />
                            </svg>
                            WhatsApp
                        </button>
                    </div>
                </div>
                <div className="p-4">
                    <div className="flex items-center justify-between space-x-4 bg-white">
                        <div className="flex items-center text-blue-600">
                            <svg className="w-5 h-5 mr-1" viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                                />
                            </svg>
                            <span className="text-sm">Like</span>
                        </div>
                        <div className="flex items-center text-blue-600">
                            <svg
                                className="w-5 h-5 mr-1 transform rotate-180"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                                />
                            </svg>
                            <span className="text-sm">Share</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};
